
const faultySensors = new Set([
  92425, 93019, 92325, 92769, 92415,
  91277, 92679, 92999, 91809, 92789, 92821,
  91819, 90599, 92785, 92807,
  92289, 93001, 92285, 90635,
  90641, 92701
]);

const purpleAirIdToLocalId = {
  92271: { locationId: 10, name: "Lettie M Dent Elementary", position: "Front" },
  91277: { locationId: 10, name: "Lettie M Dent Elementary", position: "Side" },
  92885: { locationId: 10, name: "Lettie M Dent Elementary", position: "Back" },
  92793: { locationId: 16, name: "Ridge Elementary", position: "Left Side" },
  91809: { locationId: 16, name: "Ridge Elementary", position: "Front" },
  90635: { locationId: 16, name: "Ridge Elementary", position: "Right Side" },
  90599: { locationId: 15, name: "Piney Point Elementary", position: "Back" },
  90655: { locationId: 15, name: "Piney Point Elementary", position: "Right Side" },
  92291: { locationId: 15, name: "Piney Point Elementary", position: "Front" },
  91347: { locationId: 20, name: "Spring Ridge Middle", position: "Right Side" },
  92789: { locationId: 20, name: "Spring Ridge Middle", position: "Front" },
  92821: { locationId: 20, name: "Spring Ridge Middle", position: "Back" },
  92881: { locationId: 14, name: "Park Hall Elementary", position: "Back Right" },
  91393: { locationId: 14, name: "Park Hall Elementary", position: "Front Left" },
  92859: { locationId: 14, name: "Park Hall Elementary", position: "Front Right" },
  93019: { locationId: 5, name: "George Washington Carver Elementary", position: "Back" },
  90589: { locationId: 5, name: "George Washington Carver Elementary", position: "Right Side" },
  85659: { locationId: 5, name: "George Washington Carver Elementary", position: "Front" },
  90817: { locationId: 25, name: "Great Mills High", position: "Front" },
  92289: { locationId: 27, name: "Fairlead Academy", position: "Front" },
  93001: { locationId: 27, name: "Fairlead Academy", position: "Back Left" },
  92285: { locationId: 27, name: "Fairlead Academy", position: "Back Right" },
  92281: { locationId: 11, name: "Lexington Park Elementary", position: "Back" },
  90881: { locationId: 11, name: "Lexington Park Elementary", position: "Left Side" },
  92245: { locationId: 11, name: "Lexington Park Elementary", position: "Front" },
  90647: { locationId: 7, name: "Greenview Knolls School Age Center", position: "Right Side" },
  92559: { locationId: 7, name: "Greenview Knolls School Age Center", position: "Front" },
  92325: { locationId: 7, name: "Greenview Knolls School Age Center", position: "Left Side" },
  92969: { locationId: 21, name: "Esperanza Middle", position: "Front Right" },
  83993: { locationId: 21, name: "Esperanza Middle", position: "Back Left" },
  92689: { locationId: 21, name: "Esperanza Middle", position: "Front Left" },
  90687: { locationId: 6, name: "Green Holly Elementary", position: "Back" },
  92701: { locationId: 6, name: "Green Holly Elementary", position: "Front Right" },
  85473: { locationId: 6, name: "Green Holly Elementary", position: "Front Left" },
  92803: { locationId: 17, name: "Town Creek Elementary", position: "Back Left" },
  91811: { locationId: 17, name: "Town Creek Elementary", position: "Front" },
  91819: { locationId: 17, name: "Town Creek Elementary", position: "Front Right" },
  92437: { locationId: 4, name: "Evergreen Elementary", position: "Front Left" },
  92427: { locationId: 4, name: "Evergreen Elementary", position: "Front Right" },
  92833: { locationId: 8, name: "Hollywood Elementary", position: "Front Right" },
  90849: { locationId: 8, name: "Hollywood Elementary", position: "Back" },
  85455: { locationId: 8, name: "Hollywood Elementary", position: "Front Left" },
  92769: { locationId: 26, name: "Leonardtown High", position: "Right Side" },
  92695: { locationId: 26, name: "Leonardtown High", position: "Front" },
  92683: { locationId: 26, name: "Leonardtown High", position: "Left Side" },
  92855: { locationId: 22, name: "Leonardtown Middle", position: "Back" },
  92415: { locationId: 22, name: "Leonardtown Middle", position: "Front" },
  93017: { locationId: 22, name: "Leonardtown Middle", position: "Right Side" },
  90645: { locationId: 9, name: "Leonardtown Elementary", position: "Front Left" },
  92745: { locationId: 9, name: "Leonardtown Elementary", position: "Front Right" },
  83855: { locationId: 9, name: "Leonardtown Elementary", position: "Back" },
  93027: { locationId: 2, name: "Captain Walter Francis Duke Elementary", position: "Front Left" },
  90659: { locationId: 2, name: "Captain Walter Francis Duke Elementary", position: "Front Right" },
  93015: { locationId: 1, name: "Benjamin Banneker Elementary", position: "Front" },
  93025: { locationId: 1, name: "Benjamin Banneker Elementary", position: "Right Side" },
  93013: { locationId: 1, name: "Benjamin Banneker Elementary", position: "Back" },
  92421: { locationId: 3, name: "Dynard Elementary", position: "Back" },
  92425: { locationId: 3, name: "Dynard Elementary", position: "Right Side" },
  93021: { locationId: 3, name: "Dynard Elementary", position: "Front" },
  90629: { locationId: 24, name: "Chopticon High", position: "Back" },
  91329: { locationId: 24, name: "Chopticon High", position: "Front" },
  90641: { locationId: 24, name: "Chopticon High", position: "Left Side" },
  92883: { locationId: 19, name: "Margaret Brent Middle", position: "Back" },
  92827: { locationId: 19, name: "Margaret Brent Middle", position: "Front" },
  89235: { locationId: 13, name: "Oakville Elementary", position: "Front Right" },
  92279: { locationId: 13, name: "Oakville Elementary", position: "Back" },
  92795: { locationId: 13, name: "Oakville Elementary", position: "Front Left" },
  92679: { locationId: 12, name: "Mechanicsville Elementary", position: "Back" },
  92999: { locationId: 12, name: "Mechanicsville Elementary", position: "Left Side" },
  92687: { locationId: 12, name: "Mechanicsville Elementary", position: "Front" },
  92747: { locationId: 18, name: "White Marsh Elementary", position: "Back" },
  92785: { locationId: 18, name: "White Marsh Elementary", position: "Left Side" },
  91383: { locationId: 18, name: "White Marsh Elementary", position: "Front" },
  92807: { locationId: 35, name: "Jamie L. Roberts Stadium", position: "Main" }
};

// Daily-average PM2.5 above this counts as an exceedance day (approximates the
// EPA 24-hour PM2.5 standard of 35 µg/m³; matches backend EXCEEDANCE_THRESHOLD).
const EXCEEDANCE_THRESHOLD = 34.1;

export { purpleAirIdToLocalId, faultySensors, EXCEEDANCE_THRESHOLD };